export default {
  mounted() {
    this.el.addEventListener('mouseenter', () => {
      this.handleHoverEnter()
    })

    this.el.addEventListener('mouseleave', () => {
      this.handleHoverExit()
    })
  },

  handleHoverEnter() {
    const library_area_ref = this.el.getAttribute('data-library-area-ref')
    const revision = document.querySelector('[data-search-revision]').dataset
      .searchRevision

    this.pushEvent('on-hover', { library_area_ref, revision })
  },

  handleHoverExit() {
    const library_area_ref = this.el.getAttribute('data-library-area-ref')
    this.pushEvent('hover-exit', { library_area_ref })
  }
}
